export enum SecureTokenType {
  JOINT_ACCOUNT_INVITATION = 'joint_account_invitation',
  BUSINESS_MEMBER_INVITE = 'business_member_invite',
}

export type SecureTokenBasePayload = {
  type: SecureTokenType;
  issuedAt?: number;
  expiresAt?: number;
};

export type SecureTokenPayload<T extends SecureTokenType = SecureTokenType> = SecureTokenBasePayload & {
  type: T;
};

export type JointAccountInvitationTokenPayload =
  SecureTokenPayload<SecureTokenType.JOINT_ACCOUNT_INVITATION> & {
    invitationId: string;
  };

export type BusinessMemberInviteTokenPayload = SecureTokenPayload<SecureTokenType.BUSINESS_MEMBER_INVITE> & {
  id: string;
};

export type SecureTokenEvent = JointAccountInvitationTokenPayload | BusinessMemberInviteTokenPayload;
